
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient.ts";



const NewArrivals = () => {
  const [isMobile, setIsMobile] = useState(false);

  const [arrivals, setArrivals] = useState([]);
  const [sectionMeta, setSectionMeta] = useState(null);
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 3;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchArrivals = async () => {
      // Fetch section meta from arrivals_section table
      const { data: section, error: error1 } = await supabase
        .from("arrivals_section")
        .select("*")
        .maybeSingle();

      // Fetch only products where new = true
      const { data: products, error: error2 } = await supabase
        .from("products")
        .select("*")
        .eq("new", true);

      if (!error1 && section) setSectionMeta(section);
      if (!error2 && products) setArrivals(products);
    };

    fetchArrivals();
  }, []);


  const promoIds = arrivals.filter((p) => p.is_promo).map((p) => p.id);

  const filteredProducts = arrivals
    .filter((product) => product.price_range && !product.price_range.includes("–"))
    .slice(0, 6);
  const maxIndex = Math.max(0, filteredProducts.length - visibleCount);

  const scrollTo = (index) => {
    const newIndex = Math.min(Math.max(index, 0), maxIndex);
    setCurrentIndex(newIndex);
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.offsetWidth / visibleCount;
      carouselRef.current.scrollTo({ left: newIndex * cardWidth, behavior: "smooth" });
    }
  };
  return (
    <section className="new-arrivals py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <h5 className="sub-title" style={{ fontSize: isMobile ? "16px" : "34px" }}>
                {sectionMeta?.subtitle || "New Arrivals"}
              </h5>

              <p
                style={{
                  fontSize: isMobile ? "12px" : "14px",
                  textAlign: "center",
                  maxWidth: "500px",
                  margin: "auto",
                  lineHeight: "1.5",
                }}
              >
                {sectionMeta?.description ||
                  "Explorez les derniers produits ajoutés à notre boutique. Que ce soit pour chats, chiens ou pour le jeu, trouvez ce qu’il vous faut."}
              </p>
            </div>
          </div>
        </div>
        {/* Desktop Carousel Wrapper */}
        {!isMobile && (
          <div style={{ position: "relative", margin: "0 10px" }}>

            {/* Left Arrow */}
            <button
              onClick={() => scrollTo(currentIndex - 1)}
              disabled={currentIndex === 0}
              style={{
                position: "absolute",
                left: "-45px",
                top: "45%",
                transform: "translateY(-50%)",
                zIndex: 10,
                background: currentIndex === 0 ? "#ccc" : "#ff41b4",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "36px",
                height: "36px",
                fontSize: "20px",
                cursor: currentIndex === 0 ? "default" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              ‹
            </button>

            {/* The exact same scroll-container div, just overflowX hidden now */}
            <div
              ref={carouselRef}
              className="scroll-container"
              style={{
                display: "flex",
                flexDirection: "row",
                overflowX: "hidden",
                overflowY: "hidden",
                gap: "2.5rem",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                margin: "0 0 0 0",   // ← shifted left, no right margin
              }}
            >
              {filteredProducts.map((product, index) => (
                <div
                  key={product.id}
                  className="adoption-shop-item"
                  style={{
                    flex: "0 0 calc(33.33% - 2.5rem)",
                    width: "100%",
                    backgroundColor: "#F4F1EA",
                    borderRadius: "4px",
                    padding: "10px",
                    height: "303px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Image */}
                  <Link to={`/shop-details/${product.id}`}>
                    <div
                      className="adoption-shop-thumb"
                      style={{
                        width: "100%",
                        height: "170px",
                        overflow: "hidden",
                        marginBottom: "8px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                      }}
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        style={{
                          width: product.id === 3 ? "60%" : "90%",
                          height: "90%",
                          objectFit: "contain",
                          backgroundColor: "transparent",
                        }}
                      />
                      {promoIds.includes(product.id) && (
                        <span className="badge bg-success position-absolute top-0 end-0 m-2">
                          Promo!
                        </span>
                      )}
                    </div>
                  </Link>

                  {/* Text — completely untouched */}
                  <div
                    className="adoption-shop-content"
                    style={{
                      textAlign: "center",
                      width: "90%",
                      height: "50%",
                      minHeight: "80px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      marginLeft: "15px",
                      transform: "translateY(67px)",
                    }}
                  >
                    <h6
                      className="title"
                      style={{
                        fontSize: "16px",
                        marginBottom: "6px",
                        color: "black",
                        minHeight: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Link to={`/shop-details/${product.id}`}>
                        {product.name.length > 10
                          ? product.name.substring(0, 20) + "..."
                          : product.name}
                      </Link>
                    </h6>

                    <div className="adoption-meta"><ul></ul></div>

                    {product.price_range && (
                      <div className="adoption-rating">
                        <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                          <li
                            className="price"
                            style={{
                              fontSize: "15px",
                              color: "#ff41b4",
                              fontWeight: "bold",
                              textAlign: "right",
                              transform: "translateX(60px)",
                            }}
                          >
                            <span>
                              {new Intl.NumberFormat("fr-FR", {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3,
                              }).format(parseFloat(product.price_range))}{" "}
                              DT
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Right Arrow */}
            <button
              onClick={() => scrollTo(currentIndex + 1)}
              disabled={currentIndex >= maxIndex}
              style={{
                position: "absolute",
                right: "-45px",
                top: "45%",
                transform: "translateY(-50%)",
                zIndex: 10,
                background: currentIndex >= maxIndex ? "#ccc" : "#ff41b4",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "36px",
                height: "36px",
                fontSize: "20px",
                cursor: currentIndex >= maxIndex ? "default" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              ›
            </button>

            {/* Dots */}
            <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "20px" }}>
              {Array.from({ length: maxIndex + 1 }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => scrollTo(i)}
                  style={{
                    width: i === currentIndex ? "24px" : "8px",
                    height: "8px",
                    borderRadius: "4px",
                    background: i === currentIndex ? "#ff41b4" : "#ccc",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    transition: "all 0.3s ease",
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {/* Mobile — completely untouched */}
        {isMobile && (
          <div
            className="scroll-container"
            style={{
              display: "flex",
              flexDirection: "row",
              overflowX: "auto",
              overflowY: "hidden",
              gap: "1rem",
              scrollSnapType: "x mandatory",
              padding: "0 16px",
              margin: "0",
              flexWrap: "nowrap",
              justifyContent: "flex-start",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {filteredProducts.map((product, index) => (
              <div
                key={product.id}
                className="adoption-shop-item"
                style={{
                  scrollSnapAlign: "start",
                  flex: "0 0 72%",
                  width: "auto",
                  backgroundColor: "#F4F1EA",
                  borderRadius: "4px",
                  padding: "10px",
                  height: "303px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Link to={`/shop-details/${product.id}`}>
                  <div
                    className="adoption-shop-thumb"
                    style={{
                      width: "100%",
                      height: "170px",
                      overflow: "hidden",
                      marginBottom: "8px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <img
                      src={product.image}
                      alt={product.name}
                      style={{
                        width: product.id === 3 ? "60%" : "90%",
                        height: "100%",
                        objectFit: "contain",
                        backgroundColor: "transparent",
                        transform: index === 0 ? "translateX(10%)" : "none",
                      }}
                    />
                    {promoIds.includes(product.id) && (
                      <span className="badge bg-success position-absolute top-0 end-0 m-2">
                        Promo!
                      </span>
                    )}
                  </div>
                </Link>

                <div
                  className="adoption-shop-content"
                  style={{
                    textAlign: "center",
                    width: "90%",
                    height: "50%",
                    minHeight: "80px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    marginLeft: "15px",
                    transform: "translateY(67px)",
                  }}
                >
                  <h6
                    className="title"
                    style={{
                      fontSize: "14px",
                      marginBottom: "6px",
                      color: "black",
                      minHeight: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Link to={`/shop-details/${product.id}`}>
                      {product.name.length > 10
                        ? product.name.substring(0, 17) + "..."
                        : product.name}
                    </Link>          </h6>

                  <div className="adoption-meta"><ul></ul></div>

                  {product.price_range && (
                    <div className="adoption-rating">
                      <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                        <li
                          className="price"
                          style={{
                            fontSize: "15px",
                            color: "#ff41b4",
                            fontWeight: "bold",
                            textAlign: "right",
                            transform: "translateX(35px)",
                          }}
                        >
                          <span>
                            {new Intl.NumberFormat("fr-FR", {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            }).format(parseFloat(product.price_range))}{" "}
                            DT
                          </span>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>

  );
};

export default NewArrivals;
